export const DEFAULT_WIDGET_WIDTH = 700;
export const DEFAULT_WIDGET_HEIGHT = 500;
export const DEFAULT_RESPONSIVE_SECTION_HEIGHT = 500;
